var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('h1',[_vm._v("Configuration")]),_c('p',[_vm._v(" There is no configuration needed for this version. Please only use this app for the main streaming channel for now. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }